import { FC } from 'react';

const DetailsSectionLoader: FC = () => (
    <div className="px-4 flex gap-20">
        <div className="flex flex-col gap-2">
            <span className="font-sf text-13 leading-[15.51px] text-sf-gray-500">UPN</span>
            <div className="animate-pulse">
                <div className="h-4 w-[174px] rounded-[4px] bg-sf-gray-100" />
            </div>
        </div>
        <div className="flex flex-col gap-2">
            <span className="font-sf text-13 leading-[15.51px] text-sf-gray-500">Domain</span>
            <div className="animate-pulse">
                <div className="h-4 w-[115px] rounded-[4px] bg-sf-gray-100" />
            </div>
        </div>
        <div className="flex flex-col gap-2">
            <span className="font-sf text-13 leading-[15.51px] text-sf-gray-500">Last seen</span>
            <div className="animate-pulse">
                <div className="h-4 w-[80px] rounded-[4px] bg-sf-gray-100" />
            </div>
        </div>
    </div>
);

export default DetailsSectionLoader;
